import gql from 'graphql-tag';

import { executeGqlQuery } from 'src/graphql/client';
import { getSingleProp, throwIfResultHasErrors } from 'src/lib/graphql';
import type { BackendCustomer, BackendProject, BackendQueryProjectArgs } from 'src/types/backend';

// A reviewer may read these fields under any account, so the answer comes before an account is
// picked for the project.
const QUERY = gql`
  query ProjectCustomerId($id: Int!) {
    project(id: $id) {
      id
      customer {
        id
      }
    }
  }
`;

type Variables = BackendQueryProjectArgs;
interface Result extends Pick<BackendProject, 'id'> {
  customer?: Pick<BackendCustomer, 'id'> | null;
}

/** The id of the account a project belongs to, or null when the user may not open it. */
export const queryProjectCustomerId = async (variables: Variables) => {
  const result = await executeGqlQuery({ query: QUERY, variables });
  throwIfResultHasErrors(result);
  return getSingleProp<Result>(result.data)?.customer?.id ?? null;
};
